import React from 'react';
import { Spinner } from '@venmo/venmoui/dist/icons';
import styled from '@emotion/styled';
import { VerticalAligned } from '../VerticalAligned';
import { Layout } from '../Layout';

const TextContainer = styled.div`
    margin-top: 1rem;
    text-align: center;
    font-family: 'Athletics Medium';
    font-size: 24px;
`;

const SpinnerContainer = styled.div`
    display: flex;
    text-align: center;
    justify-content: center;
`;

// TODO: replace this with a token or a prop from <Spinner />, once it's available in @venmo/venmoui
const BLUE_STROKE_COLOR_HEX = '#0074DE';

export const LoadingScreen: React.FC<{ text?: string }> = ({ text }) => {
    return (
        <Layout
            content={
                <VerticalAligned>
                    <SpinnerContainer>
                        <Spinner
                            strokeColor={BLUE_STROKE_COLOR_HEX}
                            width={40}
                            height={40}
                        />
                    </SpinnerContainer>
                    {text && <TextContainer>{text}</TextContainer>}
                </VerticalAligned>
            }
        />
    );
};
